import { render } from "./SelectAddress.vue?vue&type=template&id=656ccdc5&ts=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./SelectAddress.vue?vue&type=script&lang=ts"
export * from "./SelectAddress.vue?vue&type=script&lang=ts"

import "./SelectAddress.vue?vue&type=style&index=0&id=656ccdc5&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__